import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../weightAdjustmentAction';
import fetchApi from "./fetchApi";

function fetchWeightAdjustmentAction() {
  return fetchApi('/v1/fc_api/weight_adjustment_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchWeightAdjustmentAction;
